// extracted by mini-css-extract-plugin
export var cardTitle = "_cn-1";
export var commentBubble = "_cn-e";
export var commentForm = "_cn-a";
export var commentInput = "_cn-b";
export var commentLabel = "_cn-d";
export var commentPrompt = "_cn-9";
export var csatCard = "_cn-0";
export var feedbackSection = "_cn-7";
export var starDisabled = "_cn-6";
export var starEmpty = "_cn-5";
export var starFilled = "_cn-4";
export var starWrapper = "_cn-3";
export var starsContainer = "_cn-2";
export var submittedComment = "_cn-c";
export var thankYouText = "_cn-8";